import React from "react";
import styled from "styled-components";
import { Consumer } from "../context/InfoContext";
import Row from "../dev/Row";
import Span from "../dev/Span";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Guide from "../dev/Guide";

const PastMonth = props => {
    const { messages } = props;
    return (
        <Consumer>
            {value => (
                <PastMonthDefault>
                    <Row direction="column">
                        <Row padding="20px 24px" position={'relative'} zIndex={1}>
                            <Row>
                                <Span spanTitle>
                                    {messages.info_last_month}
                                </Span>
                                <Guide
                                    list={[
                                        messages.dataDesc_monthSubscriberCount,
                                        [`${messages.monthSubscriberRate} ${messages.dataDesc_equal}`,{numerator: messages.monthSubscriberCount, denominator: messages.dataDesc_todaySubscriberRate_2}, messages.dataDesc_monthSubscriberRate_2],
                                        messages.dataDesc_monthViewCount,
                                        [`${messages.monthViewRate} ${messages.dataDesc_equal}`,{numerator: messages.monthViewCount, denominator: messages.dataDesc_todayViewRate_2}, messages.dataDesc_monthSubscriberRate_2],
                                    ]}
                                />
                            </Row>
                        </Row>
                        <Row
                            padding="20px 24px"
                            size="0.6rem"
                            color="787878"
                            weight="300"
                            lineHeight="1.1rem"
                            position={'relative'} 
                            zIndex={0}
                            borderTop
                        >
                            <Row direction="column">
                                <Span>
                                    {
                                        messages.info_last_info_last_month_subscribers
                                    }
                                </Span>
                                <Span>
                                    {messages.info_last_info_last_month_views}
                                </Span>
                            </Row>
                            <Row direction="column" isBlur={value.isBlur}>
                                <Span>{value.monthSubscriberCount}</Span>
                                <Span>{value.monthViewCount}</Span>
                            </Row>
                            <Row direction="column">
                                <Span>
                                    {
                                        messages.info_last_info_last_month_subscriber_growth
                                    }
                                </Span>
                                <Span>
                                    {
                                        messages.info_last_info_last_month_views_growth
                                    }
                                </Span>
                            </Row>
                            <Row direction="column" isBlur={value.isBlur}>
                                <Span>{value.monthSubscriberRate}%</Span>
                                <Span>{value.monthViewRate}%</Span>
                            </Row>
                        </Row>
                    </Row>
                </PastMonthDefault>
            )}
        </Consumer>
    );
};

const mapStateToProps = state => {
    return {
        messages: state.Messages
    };
};
export default withRouter(connect(mapStateToProps)(PastMonth));
//export default PastMonth;

const PastMonthDefault = styled.div`
    position: relative;
    z-index: 0;
    grid-area: pastMonth;
    display: flex;
    background-color: #fff;
    height: auto;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
`;



// WEBPACK FOOTER //
// ./src/Info/PastMonth.js